import Http from "../../http/client";

export default async ({userId, startDate, endDate, period}) => {
    const response = await Http.get(`admin/trip-earnings-report/${userId}`, {
        params: {
            startDate,
            endDate,
            period
        }
    });

    return response.data;
}
